'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidWalk = function IoAndroidWalk(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm22.6 8.8c-1.7 0-3.1-1.5-3.1-3.2s1.4-3.1 3.1-3.1 3.2 1.4 3.2 3.1-1.5 3.2-3.2 3.2z m0 9.3l-1.5-2.9-1.6 4.8 4.5 7.5v10h-3v-7.5l-3.9-5.3-4.5 12.8h-3.1l6.3-25-3.2 1.3v6.2h-3.1v-8.7l8.7-3c0.3-0.1 0.8-0.1 1-0.1 1 0 1.8 0.5 2.4 1.4l3.5 5.4h5.6v3.1h-8.1z' })
        )
    );
};

exports.default = IoAndroidWalk;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-walk.js
// module id = 2160
// module chunks = 0